import { Avatar, Box, styled, Typography } from '@mui/material'
import { ArticleAuthorProps } from './type'

const AccountStyle = styled(Box)((/* { theme } */) => ({
  display: 'flex',
  alignItems: 'center',
}))

export const AritcleAuthor: React.FC<ArticleAuthorProps> = ({ image, name, date, ...props }) => {
  return (
    <AccountStyle {...props}>
      <Avatar alt='image' src={image} />
      <Box sx={{ ml: 2 }}>
        <Typography variant='subtitle2' sx={{ color: 'text.primary' }}>
          {name}
        </Typography>
        {date && (
          <Typography variant='body2' sx={{ color: 'text.secondary' }}>
            {date}
          </Typography>
        )}
      </Box>
    </AccountStyle>
  )
}
